import React from 'react';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import {
  InsightsDashboard,
  LuzmoConfig,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboard/InsightsDashboard';
import { getInsightsDashboardStyleProps } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardWrapper/InsightsDashboardWrapper.utils';

interface InsightsDashboardWrapperProps {
  dashboardConfig: LuzmoConfig;
  onLoaded: () => void;
  isDashboardLoading: boolean;
}

export function InsightsDashboardWrapper({
  dashboardConfig,
  onLoaded,
  isDashboardLoading,
}: InsightsDashboardWrapperProps): JSX.Element {
  const insightsDashboardStyleProps =
    getInsightsDashboardStyleProps(isDashboardLoading);

  return (
    <Stack {...insightsDashboardStyleProps}>
      <InsightsDashboard luzmoConfig={dashboardConfig} onLoaded={onLoaded} />
    </Stack>
  );
}
